
import { computed, defineComponent, PropType } from 'vue'

// @types
import { WaveInvoice } from '@/new-services/types/waves'

// @components
import Cheap from '@/common/components/UI/Cheap/index.vue'

// @enums
import { NewDispatcherStatusesEnum } from '@/core/enums/new_dispatcher.enums'

export default defineComponent({
    name: 'wave-invoice-table-row',
    props: {
        index: {
            type: Number,
            default: 1,
        },
        row: {
            type: Object as PropType<WaveInvoice>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
    },
    components: {
        Cheap,
    },
    setup(_) {
        return {
            NewDispatcherStatusesEnum,
        }
    },
})
